// Création de l'objet à envoyer au back
const formaterAdresseSecondaire = (data) => {
    return {
        nationalite: data.adresseInternationale !== null ?? false,
        numeroDeVoie: data.numeroVoie ?? null,
        extension: data.extension ?? null,
        typeEtNomDeVoie: data.libelleVoie ?? null,
        lieuDit: data.lieuDit ?? null,
        codePostal: data.codePostal ?? null,
        ville: data.ville ?? null,
        pays: data.pays.id ?? null,
        justificatifsDomicile: data.justificatifsDomicile ?? null,
        adresseInternationale: data.adresseInternationale ?? null,
    };
};

export default formaterAdresseSecondaire;
